import { z } from 'zod'
import { HouseholdId, UserId } from './ids.ts'

// Shared secret a household member gives their own family so they can join.
// Six unambiguous uppercase-alphanumeric chars (generation skips 0/O/1/I) —
// enough entropy for a family-scale app, short enough to read aloud.
export const HouseholdJoinCode = z.string().regex(/^[A-Z0-9]{6}$/)
export type HouseholdJoinCode = z.infer<typeof HouseholdJoinCode>

export const Household = z.object({
	id: HouseholdId,
	name: z.string().min(1).max(100).nullable(),
	joinCode: HouseholdJoinCode,
	createdAt: z.iso.datetime(),
})
export type Household = z.infer<typeof Household>

// PATCH /household. Any member can rename — there is no owner/admin concept
// in the model, matching how anyone can already delete any recipe.
export const HouseholdUpdateBody = z
	.object({
		name: z.string().min(1).max(100).optional(),
	})
	.refine((b) => b.name !== undefined, { message: 'name must be provided' })
export type HouseholdUpdateBody = z.infer<typeof HouseholdUpdateBody>

export const HouseholdUpdateResponse = z.object({ household: Household })
export type HouseholdUpdateResponse = z.infer<typeof HouseholdUpdateResponse>

// Slim view of a household member for assignee pickers and initials — just
// what the client needs to render, no email.
export const HouseholdMember = z.object({
	id: UserId,
	displayName: z.string().min(1).max(100).nullable(),
})
export type HouseholdMember = z.infer<typeof HouseholdMember>

export const HouseholdMembersResponse = z.object({
	members: z.array(HouseholdMember),
})
export type HouseholdMembersResponse = z.infer<typeof HouseholdMembersResponse>
